<template>
  <a-table :columns="columns" :data-source="data"  :pagination="pagination" @change="handleTableChange" bordered>
    <a slot="name" slot-scope="text, record">
	 <a-avatar :src="record.avatar" />
	{{ text }} </a>
    <span slot="customTitle"><a-icon type="user" /> 评价人 </span>
	<span slot="productName" slot-scope="text, record">
		商品名称：{{record.productName}}
		<br>
		规格：{{record.specification}}
		<br>
		价格：<span style="color: red;">{{record.finallyPrice}} 元</span>
		
	</span>
	<span slot="specificationPic" slot-scope="text, record">
		<img style="width: 40px;" :src="text" alt="">
	</span>
	
	<span slot="image" slot-scope="text, record">
		<span v-if="text.length != 0">
			<span v-for="img in text" :key="img">
				<img style="width: 40px;" :src="img" alt="">
			</span>
		</span>
		<span v-else>
			[暂无图片]
		</span>
	</span>
	<span slot="content" slot-scope="text, record">
		<span v-if="text.length != 0">
			{{text}}
		</span>
		<span v-else>
			此用户未填写评价。
		</span><br />
		[{{record.addTime}}]
	</span>
	
    <span slot="evaluate" slot-scope="evaluate">
      <a-tag v-if="evaluate == 1" :color="'green'">
			好评
      </a-tag>
	  <a-tag v-if="evaluate == 2" :color="'geekblue'">
	  		中评
	  </a-tag>
	  <a-tag v-if="evaluate == 3" :color="'red'">
	  		差评
	  </a-tag>
    </span>
  </a-table>
</template>
<script>
const columns = [
  {
    dataIndex: 'name',
    key: 'name',
    slots: { title: 'customTitle' },
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '商品名称',
    dataIndex: 'productName',
    key: 'productName',
	scopedSlots: { customRender: 'productName' },
  },
  {
    title: '商品图片',
    dataIndex: 'specificationPic',
    key: 'specificationPic',
  	scopedSlots: { customRender: 'specificationPic' }
  },
  {
    title: '评论图片',
    dataIndex: 'image',
    key: 'image',
	scopedSlots: { customRender: 'image' }
  },
  {
    title: '评论内容',
    dataIndex: 'content',
    key: 'content',
	scopedSlots: { customRender: 'content' }
  },
  {
    title: '评价',
    key: 'evaluate',
    dataIndex: 'evaluate',
    scopedSlots: { customRender: 'evaluate' },
  }
];


import api from '../../api/Api.js';

export default {
  data() {
    return {
		data:[],
		columns,
		page:0,
		pagination: { current: 0, pageSize: 10, total: 55 },
    };
  },
  mounted() {
  	this.getProductEvaluate();
  },
  methods:{
	  getProductEvaluate(){
		  const that = this;
		  let url = 'api/store/v1/company/evaluate/storeEvaluateList';
		  let param = {
			  page: that.page
		  };
		api.postRequest(url, param, res => {
			if(res.status == 200){
				that.data = res.data.data;
				that.pagination.total = res.data.maxCount;
				that.data.forEach((item, index, array) => {
					item.key = index;
					item.finallyPrice = item.finallyPrice + '';
					var arr = item.finallyPrice.split('');
					var finallyPrice = '';
					for (var i = 0; i < arr.length; i++) {
						finallyPrice += arr[i];
						if (i == arr.length - 3) {
							finallyPrice += '.';
						}
					}
					item.finallyPrice = finallyPrice;
				});
				console.log(that.data)
			}
		});
	  },
	  handleTableChange(pagination, filters, sorter) {
	  	this.pagination = pagination;
	  	this.page = this.pagination.current - 1;
	  	this.getProductEvaluate();
	  },
  }
  
};
</script>